import { useContext, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { getTranslation } from "../../utils/translations";

export default function CityPartnerContract() {
  const { lang } = useContext(LanguageContext);
  const t = getTranslation(lang);
  const [open, setOpen] = useState(false);

  return (
    <section
      style={{
        marginTop: 30,
        background: "#ffffff",
        color: "#0f172a",
        borderRadius: 12,
        padding: 22,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>
            {t.city_partner.contract.title}
          </h2>
          <p style={{ marginTop: 8, color: "#475569" }}>
            {t.city_partner.contract.subtitle}
          </p>
        </div>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          style={{
            background: "#0D3B66",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 16px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {open
            ? t.city_partner.contract.hide_contract
            : t.city_partner.contract.view_contract}
        </button>
      </div>

      {open && (
        <div style={{ marginTop: 24, lineHeight: 1.75, color: "#1e293b" }}>
          <h3>{t.city_partner.contract.purpose_title}</h3>
          <p>{t.city_partner.contract.purpose}</p>

          <h3>{t.city_partner.contract.term_title}</h3>
          <p>{t.city_partner.contract.term}</p>

          <h3>{t.city_partner.contract.territory_title}</h3>
          <p>{t.city_partner.contract.territory}</p>

          <h3>{t.city_partner.contract.fee_title}</h3>
          <p>{t.city_partner.contract.fee}</p>
          <p>{t.city_partner.contract.fee_note}</p>

          <h3>{t.city_partner.contract.revenue_title}</h3>
          <p>{t.city_partner.contract.revenue}</p>

          <h3>{t.city_partner.contract.partner_responsibilities_title}</h3>
          <ul style={{ paddingLeft: 20 }}>
            {t.city_partner.contract.partner_responsibilities.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <h3>{t.city_partner.contract.platform_responsibilities_title}</h3>
          <ul style={{ paddingLeft: 20 }}>
            {t.city_partner.contract.platform_responsibilities.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <h3>{t.city_partner.contract.performance_title}</h3>
          <p>{t.city_partner.contract.performance}</p>

          <h3>{t.city_partner.contract.ip_title}</h3>
          <p>{t.city_partner.contract.ip}</p>

          <h3>{t.city_partner.contract.data_title}</h3>
          <p>{t.city_partner.contract.data}</p>

          <h3>{t.city_partner.contract.payments_title}</h3>
          <p>{t.city_partner.contract.payments}</p>

          <h3>{t.city_partner.contract.relationship_title}</h3>
          <p>{t.city_partner.contract.relationship}</p>

          <h3>{t.city_partner.contract.termination_title}</h3>
          <p>{t.city_partner.contract.termination}</p>

          <h3>{t.city_partner.contract.termination_effect_title}</h3>
          <p>{t.city_partner.contract.termination_effect}</p>

          <h3>{t.city_partner.contract.law_title}</h3>
          <p>{t.city_partner.contract.law}</p>

          <h3>{t.city_partner.contract.final_note_title}</h3>
          <p>{t.city_partner.contract.final_note}</p>
        </div>
      )}
    </section>
  );
}